import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

function SEO({ title, description, keywords, image, url, type = 'website', schema, canonical }) {
  const location = useLocation();
  const siteTitle = 'Pokemon Stats Database';
  const siteDescription = 'Complete Pokemon Stats Database with 1,215+ Pokemon,detailed statistics,abilities,types,and comparison tools';
  const siteUrl = 'https://example.com';

  const fullTitle = title ? `${title} | ${siteTitle}` : `${siteTitle} - Complete Pokemon Reference & Statistics`;
  const fullDescription = description || siteDescription;
  
  // Dynamic URL construction:
  // Prefer 'url' prop if provided (allows overriding or explicit relative paths)
  // Fallback to location.pathname + location.search for automatic current page URL
  const path = url || (location.pathname + location.search);
  
  // Handle absolute vs relative paths
  // If path is root '/', we leave it empty to avoid trailing slash if desired, or handle consistently
  const fullUrl = path.startsWith('http') ? path : `${siteUrl}${path === '/' ? '' : path}`;
  
  const fullImage = image || `${siteUrl}/pokemon-og.jpg`;
  const canonicalUrl = canonical || fullUrl;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={fullDescription} />
      {keywords && <meta name="keywords" content={keywords} />}

      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDescription} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:site_name" content={siteTitle} />

      {/* Twitter Cards */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={fullDescription} />
      <meta name="twitter:image" content={fullImage} />

      {/* Schema.org JSON-LD */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
}

export default SEO;